/* eslint-disable no-obj-calls */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router";
import { ReactComponent as LeftArrow } from "../../assets/icons/arrows/left-arrow.svg";
import {
  ControlledInput,
  ControlledSelect,
  FormInput,
  PrimaryButton,
  RedButton,
  SecondaryButton,
} from "../../components";
import { useEffect, useMemo, useState } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useUsers } from "../../store/useUsers";
import { useForm } from "react-hook-form";
import { useDrops } from "../../store/useDrops";
import { UserDropsList } from "./UserDropsList";
import { LOG } from "../../utils/logUtil";
import { useTomraDrops } from "../../store/useTomraDrops";
import { TomraDropsTable } from "./TomraDropsTable";
import { useAlert } from "../../store/useAlert";
import { useAuth } from "../../store/useAuth";
import { useDropLocations } from "../../store/useDropLocations";
import { useDonations } from "../../store/useDonations";
import { WithdrawTable } from "./WithdrawTable";
import { useBeevisionDrops } from "../../store/useBeevisionDrops";
import { BeevisionUserDropsTable } from "./BeevisionDropsTable";
import { useWithdraws } from "../../store/useWithdraws";
import { UserWithdrawsTable } from "./UserWithdrawsTable";
import { useTransactionLogs } from "../../store/useTransactionLogs";
import { UserTransactionLogsTable } from "./UserTransactionLogsTable";

type Inputs = {
  email: string;
  first_name: string;
  last_name?: string;
  phone_number?: string;
  user_role?: "1" | "2" | "3" | "4" | "5" | "6" | "7";
  location?: string;
  password?: string;
  postal_code?: string;
  defaultLocation?: string;
};

function EditUserScreen() {
  /** Params */
  const params = useParams();
  /** Hooks */
  const { user } = useAuth();
  const { getDropLocations, dropLocations } = useDropLocations();
  // Only Super Admin can add balance
  const canAddBalance = Number(user?.user_role ?? 0) === 7;
  const {
    getWithdraws,
    withdraws,
    hasNextPage: hasUserWithdrawsNextPage,
  } = useWithdraws();
  const { userLogs, hasNextUserLogsPage, getTransactionLogsByUser } =
    useTransactionLogs();
  const {
    userStats,
    getUserStats,
    oneUser,
    getOneUser,
    updateUserInfo,
    updateUser,
    updatedUser,
    clearUpdatedUser,
    addBalance,
    blockUser,
    unblockUser,
  } = useUsers();
  const { setAlert } = useAlert();
  const { getUserDrops, hasNextUserDrops, userDrops, clearUserDrops } =
    useDrops();
  const {
    userTomraDrops,
    hasNextUserTomraDrops,
    getUserTomraDrops,
    clearUserTomraDrops,
  } = useTomraDrops();
  const {
    userBeevisionDrops,
    hasNextUserBeevisionDrops,
    getUserBeevisionDrops,
    clearUserBeevisionDrops,
  } = useBeevisionDrops();
  const {
    getUserDonations,
    userDonations,
    hasNextUserDonations,
    clearUserDonations,
  } = useDonations();
  const navigate = useNavigate();
  const location = useLocation();
  const usersListLocation = (
    location.state as { usersListLocation?: string } | null
  )?.usersListLocation;
  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      email: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      user_role: "3",
      location: "",
      postal_code: "",
      defaultLocation: "",
    },
  });
  /** State */
  const [userQrCode, setUserQrCode] = useState<string | null>(null);
  const [houseHold, setHouseHold] = useState<string | null>(null);
  const [modal, setShowModal] = useState(false);
  const [payoutAmount, setPayoutAmount] = useState<string>("");
  const [userDropsPage, setUserDropsPage] = useState<number>(1);
  const [userTomraDropsPage, setUserTomraDropsPage] = useState<number>(1);
  const [userBeevisionDropsPage, setUserBeevisionDropsPage] =
    useState<number>(1);
  const [userDonationsPage, setUserDonationsPage] = useState<number>(1);
  const [userWithdrawsPage, setUserWithdrawsPage] = useState<number>(1);
  const [userTransactionLogsPage, setUserTransactionLogsPage] =
    useState<number>(1);

  // const isSuperAdmin =
  //   oneUser?._id === "65e8422d963023ff80651688" &&
  //   oneUser?.user_role === 1 &&
  //   oneUser?.email === "admin@test.com";

  const isSuperAdmin = Number(user?.user_role ?? 0) === 7;

  const isAdminOrManager = [1, 2, 5, 7].includes(Number(user?.user_role ?? 0));

  /** Effects */
  useEffect(() => {
    if (params?.id) {
      getUserStats(params?.id as string);
      getOneUser(params?.id as string);
      getUserDrops(params?.id as string, 1, 10);
      getUserTomraDrops(params?.id as string, 1, 10);
      getUserBeevisionDrops(params?.id as string, 1, 10);
      getUserDonations(params?.id as string, 1, 10);
      getWithdraws(params?.id as string, 1, 10);
      getTransactionLogsByUser(params?.id as string, 1, 10);
    }
  }, [params?.id]);

  useEffect(() => {
    if (oneUser) {
      reset({
        email: oneUser.email as string,
        first_name: oneUser.first_name as string,
        last_name: oneUser.last_name as string,
        phone_number: oneUser.phone_number as string,
        user_role: (oneUser.user_role as "1") || "2" || "3",
        location: oneUser.location as string,
        postal_code: oneUser.postal_code ?? "",
        defaultLocation: oneUser.defaultLocation ?? "",
      });
      if (oneUser?.user_info?.house_hold) {
        setHouseHold(String(oneUser?.user_info?.house_hold ?? 0));
      }
      if (oneUser?.qrCode) {
        setUserQrCode(oneUser?.qrCode);
      } else {
        generateQRCode();
      }
    }
  }, [oneUser]);

  useEffect(() => {
    if (updatedUser) {
      if (window.history?.length && window.history?.length > 1) {
        navigate(-1);
      } else {
        navigate(usersListLocation ?? "/users", { replace: true });
      }
    }
  }, [updatedUser]);

  useEffect(() => {
    getDropLocations();
    return () => {
      clearUpdatedUser();
      clearUserDrops();
      clearUserTomraDrops();
      clearUserBeevisionDrops();
      clearUserDonations();
    };
  }, []);

  /** Callbacks */

  // Phone login refuses a number unused for long (6 months, or what Firebase
  // Remote Config's phone_unused_login_months says) when the account also signs in
  // with Google or Apple (backend recycledNumbers.service.ts). Once support has
  // checked that the number is the person's, this opens it again.
  const confirmPhone = async () => {
    const ok = window.confirm(
      `Have you checked that ${oneUser?.phone_number} belongs to ${oneUser?.first_name ?? "this person"}? ` +
        "Phone login with this number then opens the account again."
    );
    if (!ok) return;
    try {
      await axios.post(`users/${params?.id}/phone-checked`);
      setAlert({ isOpen: true, message: "Phone login works again for this number.", severity: "success" });
    } catch (error: any) {
      // axiosConfig rejects with the response itself.
      setAlert({
        isOpen: true,
        message: error?.data?.message ?? error?.response?.data?.message ?? "Could not confirm the number.",
        severity: "error",
      });
    }
  };

  const initializePayout = () => {
    if (!payoutAmount) {
      setAlert({
        isOpen: true,
        message: "Please enter an amount.",
        severity: "error",
      });
      return;
    }
    setPayoutAmount("");
    setShowModal(false);
    const confirmDelete = window.confirm(
      `Are you sure you want to add this balance to ${oneUser?.first_name} ${oneUser?.last_name} ?`
    );
    if (confirmDelete) {
      addBalance(params?.id as string, Number(payoutAmount ?? 0) * 100);
    }
  };

  const averageDropValue = useMemo(() => {
    const totalDrops =
      Number(oneUser?.dropsVolume ?? 0) +
      Number(oneUser?.tomraDropsVolume ?? 0) +
      Number(oneUser?.beevisionDropsVolume ?? 0);
    const totalDropsAmount = Number(oneUser?.totalRevenue ?? 0) / 100;
    return totalDrops > 0 ? totalDropsAmount / totalDrops : 0;
  }, [
    oneUser?.dropsVolume,
    oneUser?.tomraDropsVolume,
    oneUser?.beevisionDropsVolume,
    oneUser?.totalRevenue,
  ]);

  const generateQRCode = async () => {
    try {
      const response = await fetch(
        `https://api.qrserver.com/v1/create-qr-code/?data=${oneUser?._id}&size=220x220`
      );
      const jsonResponse = await response.blob();
      //Generate blob
      // @ts-ignore
      var blob = new Blob([jsonResponse], {
        type: "text/vtt; charset=utf-8",
      });

      const fileReaderInstance = new FileReader();
      fileReaderInstance.readAsDataURL(blob);
      fileReaderInstance.onload = () => {
        setUserQrCode(fileReaderInstance.result as string);
      };
      // setUserQrCode(URL.createObjectURL(jsonResponse));
    } catch (error) {
      LOG.error("Error on generating QR code", { error });
    }
  };

  const handlePrintQrCode = () => {
    const printWindow = window.open("", "_blank");
    // printWindow?.document?.write(
    //   "<html><head><title>Print QR Code</title></head><body>"
    // );
    printWindow?.document?.write(
      `<img src="${userQrCode}" style="width:100%; max-width:300px;"/>`
    );
    printWindow?.document.write("</body></html>");
    printWindow?.document.close();
    printWindow?.focus();
    printWindow?.print();
    printWindow?.close();
  };

  const handleCopyUserId = async () => {
    const idToCopy = oneUser?._id;
    if (!idToCopy) return;
    try {
      await navigator.clipboard.writeText(idToCopy);
      setAlert({
        isOpen: true,
        message: "User ID copied to clipboard",
        severity: "success",
      });
    } catch (error) {
      LOG.error("Error on copying user id", { error });
      setAlert({
        isOpen: true,
        message: "Failed to copy User ID",
        severity: "error",
      });
    }
  };

  const goBack = () => {
    if (usersListLocation) {
      navigate(usersListLocation, { replace: true });
      return;
    }
    navigate(-1);
  };
  const onSubmit = (data: Inputs) => {
    let newData = { ...data };
    if (!newData?.password) {
      delete newData.password;
    }
    updateUser(params?.id as string, {
      ...newData,
      location: data?.location ?? "Amsterdam",
      user_role: Number(data?.user_role),
      defaultLocation: data?.defaultLocation ?? "",
    });
    if (Number(houseHold) !== oneUser?.user_info?.house_hold) {
      // @ts-ignore
      updateUserInfo(params?.id as string, {
        ...oneUser?.user_info,
        house_hold: Number(houseHold),
      });
    }
  };
  const addDrop = () => navigate(`/add-drop/${params?.id}`);

  const handleToggleBlock = () => {
    if (!params?.id) return;
    if (oneUser?.isBlocked) {
      const confirmUnblock = window.confirm(
        `Are you sure you want to unblock ${oneUser?.first_name} ${oneUser?.last_name}?`
      );
      if (confirmUnblock) {
        unblockUser(params?.id as string);
      }
    } else {
      const confirmBlock = window.confirm(
        `Are you sure you want to block ${oneUser?.first_name} ${oneUser?.last_name}?`
      );
      if (confirmBlock) {
        blockUser(params?.id as string);
      }
    }
  };

  function capitalizeFirstWord(str: string) {
    if (!str) return str; // Return the original string if it's empty or undefined
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <div>
      <div className="flex flex-row items-center justify-between mb-6">
        <div className="flex flex-row items-center">
          <LeftArrow onClick={goBack} className="mr-3 cursor-pointer" />
          <h1 className="font-satoshi text-2xl font-bold text-dark">
            {oneUser?.first_name} {oneUser?.last_name}
          </h1>
        </div>
        <div className="flex flex-row items-center gap-4">
          {isSuperAdmin ? (
            oneUser?.isBlocked ? (
              <RedButton label="Unblock account" onClick={handleToggleBlock} />
            ) : (
              <RedButton label="Block account" onClick={handleToggleBlock} />
            )
          ) : null}
          {canAddBalance ? (
            <div>
              <PrimaryButton
                label="Add balance"
                onClick={() => setShowModal(true)}
              />
            </div>
          ) : null}
        </div>
      </div>
      {/* Top Stats */}
      <div className="flex flex-col sm:flex-row w-full p-2 sm:p-7 bg-white  border-gray-border drop-shadow-none rounded-xl sm:h-28 mb-1 sm:mb-10">
        {oneUser?.platform ? (
          <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
            <div className="flex items-center mb-1">
              {oneUser?.platform === "ios" && (
                <img
                  className="w-[30px] h-[30px]"
                  alt="ios-logo"
                  src={require("../../assets/icons/platforms/apple.png")}
                />
              )}
              {oneUser?.platform === "android" && (
                <img
                  className="w-[30px] h-[30px]"
                  alt="android-logo"
                  src={require("../../assets/icons/platforms/android.png")}
                />
              )}
              {/* <GreenChevronUp className="ml-2" /> */}
              {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              18%
            </p> */}
            </div>
            <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
              User platform
            </p>
          </div>
        ) : null}
        {oneUser?.leading_source?.name ? (
          <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
            <div className="flex items-center mb-1">
              <p className="font-satoshi text-2xl text-dark font-bold">
                {oneUser?.leading_source?.name ?? ""}
              </p>
              {/* <GreenChevronUp className="ml-2" /> */}
              {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              18%
            </p> */}
            </div>
            <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
              Leading source
            </p>
          </div>
        ) : null}
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {oneUser?.user_info?.user_settings?.payment_method === "personal"
                ? "👝"
                : "🌱"}{" "}
              {capitalizeFirstWord(
                oneUser?.user_info?.user_settings?.payment_method ?? ""
              )}
            </p>
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Payment method
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {new Intl.NumberFormat("nl-NL", {
                style: "currency",
                currency: "EUR",
              }).format(Number(Number(userStats?.totalWithdrawed ?? 0) / 100))}
            </p>
            {/* <GreenChevronUp className="ml-2" /> */}
            {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              25%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Total Pay-out
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {new Intl.NumberFormat("nl-NL", {
                style: "currency",
                currency: "EUR",
              }).format(Number(Number(oneUser?.balance ?? 0) / 100))}
            </p>
            {/* <GreenChevronUp className="ml-2" /> */}
            {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              25%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Current balance
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {Number(userStats?.totalDropsWeight?.[0]?.total ?? 0)?.toFixed(2)}{" "}
              {" kg"}
            </p>
            {/* <GreenChevronUp className="ml-2" />
            <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              25%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Total drops weight
          </p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row w-full p-2 sm:p-7 bg-white  border-gray-border drop-shadow-none rounded-xl  d sm:h-28 mb-1 sm:mb-10">
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {Number(userStats?.totalCO2Saved ?? 0)?.toFixed(2)} {" kg"}
            </p>
            {/* <GreenChevronUp className="ml-2" />
            <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              25%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Total CO2 saved
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {Number(oneUser?.tomraDropsVolume ?? 0) +
                Number(oneUser?.dropsVolume ?? 0) +
                Number(oneUser?.beevisionDropsVolume ?? 0)}
            </p>
            {/* <OrangeChevronUp className="ml-2" /> */}
            {/* <p className="ml-1 font-satoshi text-sm text-yellow font-medium">
              7%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Amount of drops
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              {new Intl.NumberFormat("nl-NL", {
                style: "currency",
                currency: "EUR",
              }).format(Number(Number(averageDropValue ?? 0) / 100))}
            </p>
            {/* <GreenChevronUp className="ml-2" /> */}
            {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              12%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Average drop value
          </p>
        </div>
        <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              €{Number(Number(oneUser?.amountDonated ?? 0) / 100)?.toFixed(2)}
            </p>
            {/* <GreenChevronUp className="ml-2" /> */}
            {/* <p className="ml-1 font-satoshi text-sm text-cc-green font-medium">
              12%
            </p> */}
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Total money donated to community
          </p>
        </div>
        {/* <div className="flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full py-2 sm:py-0">
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-2xl text-dark font-bold">
              €
              {Number(Number(userStats?.totalWithdrawed ?? 0) / 100)?.toFixed(
                2
              )}
            </p>
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 sm:ml-0">
            Total money withdrawed
          </p>
        </div> */}
      </div>
      <div className="flex flex-col sm:flex-row">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full sm:w-1/2 min-w-fit p-7 bg-white  border-gray-border drop-shadow-none rounded-xl mb-1 sm:mb-0"
        >
          {/* Email */}
          <ControlledInput
            control={control}
            error={Boolean(errors?.first_name)}
            label="First name"
            placeholder="Enter first name here..."
            name="first_name"
            rules={{ required: true }}
          />
          <ControlledInput
            control={control}
            error={Boolean(errors?.last_name)}
            label="Last name"
            placeholder="Enter last name here..."
            name="last_name"
            rules={{ required: false }}
          />
          <ControlledInput
            control={control}
            error={Boolean(errors?.email)}
            label="Email"
            placeholder="Enter email here..."
            name="email"
            type="email"
            rules={{ required: true, pattern: /^\S+@\S+$/i }}
          />
          {/* The number signs in to the account by SMS: super admins change it (the backend refuses others). */}
          <ControlledInput
            control={control}
            error={Boolean(errors?.phone_number)}
            label={isSuperAdmin ? "Phone number" : "Phone number (a super admin can change it)"}
            placeholder="Enter phone number here..."
            name="phone_number"
            type="tel"
            disabled={!isSuperAdmin}
            rules={{ required: false }}
          />
          {isSuperAdmin && oneUser?.phone_number ? (
            <div className="flex flex-col justify-end">
              <SecondaryButton type="button" onClick={confirmPhone} label="Phone checked: allow phone login" />
              <span className="mt-1 text-xs text-gray-600">
                When phone login asks them to use Google or Apple and they cannot.
              </span>
            </div>
          ) : null}
          {/* Location */}
          <ControlledInput
            control={control}
            error={Boolean(errors?.location)}
            label="Location"
            placeholder="Enter location here..."
            name="location"
            rules={{ required: false }}
          />
          {/* Postal code */}
          <ControlledInput
            control={control}
            error={Boolean(errors?.postal_code)}
            label="Postalcode"
            placeholder="Enter postalcode here..."
            name="postal_code"
            rules={{ required: false }}
          />
          {/* House hold */}
          <FormInput
            label="House hold"
            placeholder="Add House hold"
            value={houseHold ?? "0"}
            onChange={(e) => setHouseHold(e.target.value)}
          />
          {/* Password: it signs in to the account, so super admins set it (the backend refuses others). */}
          {isSuperAdmin ? (
            <ControlledInput
              control={control}
              label="Password"
              type="password"
              placeholder="Enter password"
              name="password"
              rules={{ required: false }}
            />
          ) : null}
          {isSuperAdmin ? (
            <ControlledSelect
              name="user_role"
              control={control}
              rules={{ required: true }}
              error={Boolean(errors?.user_role)}
              label="User role"
              options={[
                { _id: "7", title: "Super Admin" },
                { _id: "1", title: "Admin" },
                { _id: "5", title: "Store Admin" },
                { _id: "2", title: "Manager" },
                { _id: "3", title: "User" },
                { _id: "4", title: "External Viewer" },
                { _id: "6", title: "Plastic Viewer" },
              ]}
              placeholder="Pick user role here"
            />
          ) : null}
          {isAdminOrManager || isSuperAdmin ? (
            <ControlledSelect
              name="defaultLocation"
              control={control}
              rules={{ required: true }}
              error={Boolean(errors?.defaultLocation)}
              label="Default drop location"
              options={dropLocations?.map((location) => ({
                _id: location._id as string,
                title: location?.cost_place as string,
              }))}
              placeholder="Pick default drop location here"
            />
          ) : null}
          <div className="flex flex-row items-center justify-end">
            <SecondaryButton type="button" onClick={goBack} label="Cancel" />
            <PrimaryButton type="submit" className="ml-4" label="Save" />
          </div>
        </form>
        {/* Profile Picture */}
        <div className="w-full sm:w-1/3">
          <div className="w-full sm:ml-8 bg-white  border-gray-border drop-shadow-none rounded-xl h-[360px]">
            <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
              <p className="font-satoshi font-medium text-base text-dark">
                Profile picture
              </p>
            </div>
            <div className="flex w-full px-7 py-7 justify-center items-center">
              {oneUser?.profileImage ? (
                <img
                  className="w-[250px] h-[250px] rounded-full object-cover"
                  alt="profile_picture"
                  src={oneUser?.profileImage}
                />
              ) : (
                <p className="font-satoshi text-base text-dark">
                  No profile picture
                </p>
              )}
            </div>
          </div>
          <div className="w-full min-w-96 sm:ml-8 bg-white  border-gray-border drop-shadow-none rounded-xl h-[430px] mt-2">
            <div className="w-full border-b border-gray-border px-[28px] py-[15px] flex flex-row justify-between items-center">
              <p className="font-satoshi font-medium text-base text-dark">
                QR Code
              </p>
              <SecondaryButton
                onClick={handlePrintQrCode}
                label="Print QR Code"
                className="h-10"
              />
            </div>
            <div className="px-7 pt-4">
              <p className="font-satoshi text-xs text-gray-500">User ID</p>
              <div className="flex items-center justify-between gap-3 mt-1">
                <p className="font-satoshi font-semibold text-dark break-all">
                  {oneUser?._id ?? "-"}
                </p>
                <SecondaryButton
                  onClick={handleCopyUserId}
                  label="Copy"
                  className="h-8 px-3 text-xs"
                />
              </div>
            </div>
            <div className="flex w-full px-7 py-7 justify-center items-center">
              {userQrCode ? (
                <img
                  className="w-[250px] h-[250px] object-cover"
                  alt="profile_picture"
                  src={userQrCode ?? undefined}
                />
              ) : (
                <p className="font-satoshi text-base text-dark">No QR code</p>
              )}
            </div>
          </div>
          {oneUser?.invitedBy ? (
            <div className="w-full sm:ml-8 bg-white  border-gray-border drop-shadow-none rounded-xl h-[200px] mt-2">
              <div className="w-full bg-primary-lightest border-b border-gray-border px-[28px] py-[15px]">
                <p className="font-satoshi font-medium text-base text-primary-darkest">
                  Invited by
                </p>
              </div>
              <div className="w-full bg-gray-50 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-medium text-base">
                <p className="flex flex-row items-center justify-start flex-1">
                  First name
                </p>
                <p className="flex-row items-center justify-center sm:flex-1">
                  Last name
                </p>
              </div>
              <div
                onClick={() => {
                  const invited = oneUser?.invitedBy as
                    | { _id?: string }
                    | undefined;
                  if (!invited?._id) return;
                  navigate(`/edit-user/${invited._id}`, {
                    state: usersListLocation
                      ? { usersListLocation }
                      : location.state,
                  });
                }}
                className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base cursor-pointer"
              >
                <p className="flex flex-row items-center justify-start flex-1">
                  {/* @ts-ignore */}
                  {oneUser?.invitedBy?.first_name}
                </p>
                <p className="flex-row items-center justify-center sm:flex-1">
                  {/* @ts-ignore */}
                  {oneUser?.invitedBy?.last_name}
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Drops
          <div className="flex">
            <PrimaryButton
              onClick={addDrop}
              label="Add new drop"
              className="h-10 mr-4"
            />
          </div>
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!userDrops?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no user drop created yet.
            </p>
          ) : (
            <UserDropsList userId={params?.id as string} />
          )}
        </div>
        {hasNextUserDrops ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                setUserDropsPage(userDropsPage + 1);
                getUserDrops(params?.id as string, userDropsPage + 1, 10);
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>

      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Statiegeld Drops
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!userTomraDrops?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no user statiegeld drop created yet.
            </p>
          ) : (
            <TomraDropsTable />
          )}
        </div>
        {hasNextUserTomraDrops ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                setUserTomraDropsPage(userTomraDropsPage + 1);
                getUserTomraDrops(
                  params?.id as string,
                  userTomraDropsPage + 1,
                  10
                );
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>
      {/* User Beevision drops */}
      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Beevision Drops
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!userBeevisionDrops?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no user Beevision drop created yet.
            </p>
          ) : (
            <BeevisionUserDropsTable />
          )}
        </div>
        {hasNextUserBeevisionDrops ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                setUserBeevisionDropsPage(userBeevisionDropsPage + 1);
                getUserBeevisionDrops(
                  params?.id as string,
                  userBeevisionDropsPage + 1,
                  10
                );
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>

      {/* User donations */}
      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Donations
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!userDonations?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no user donation created yet.
            </p>
          ) : (
            <WithdrawTable />
          )}
        </div>
        {hasNextUserDonations ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                setUserDonationsPage(userDonationsPage + 1);
                getUserDonations(
                  params?.id as string,
                  userDonationsPage + 1,
                  10
                );
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>

      {/* User transaction logs */}
      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Transaction logs
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!userLogs?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no transaction log for this user yet.
            </p>
          ) : (
            <UserTransactionLogsTable userId={params?.id as string} />
          )}
        </div>
        {hasNextUserLogsPage ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                const nextPage = userTransactionLogsPage + 1;
                setUserTransactionLogsPage(nextPage);
                getTransactionLogsByUser(params?.id as string, nextPage, 10);
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>

      {/* User withdraws */}
      <div className="mt-12">
        <div className="flex w-full justify-between mb-3">
          {oneUser?.first_name}'s Withdraws
        </div>
        <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
          {!withdraws?.length ? (
            <p className="text-center font-satoshi text-base text-dark">
              There is no user withdraw created yet.
            </p>
          ) : (
            <UserWithdrawsTable />
          )}
        </div>
        {hasUserWithdrawsNextPage ? (
          <div className="flex flex-row w-full items-center justify-end mt-3">
            <PrimaryButton
              onClick={() => {
                setUserWithdrawsPage(userWithdrawsPage + 1);
                getWithdraws(params?.id as string, userWithdrawsPage + 1, 10);
              }}
              label="Load more"
              className="h-10"
            />
          </div>
        ) : null}
      </div>
      {/* Add Balance Modal */}
      {modal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-10/12 sm:w-1/4 my-0 sm:my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold font-satoshi text-dark">
                    Payout to {oneUser?.first_name} {oneUser?.last_name}
                  </h3>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <p className="font-satoshi text-dark font-extrabold text-lg text-center">
                    Current balance:{" "}
                    {new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "EUR",
                    }).format(Number(oneUser?.balance ?? 0) / 100)}
                    <p className="text-green-600">
                      {payoutAmount
                        ? ` + ${new Intl.NumberFormat("nl-NL", {
                            style: "currency",
                            currency: "EUR",
                          }).format(Number(payoutAmount))}`
                        : ""}
                    </p>
                  </p>
                  <FormInput
                    inputClassName="mt-4"
                    placeholder="Enter amount"
                    type="number"
                    value={payoutAmount}
                    onChange={(e) => setPayoutAmount(e.target.value)}
                  />
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <RedButton
                    label="Cancel"
                    className="mr-4"
                    onClick={() => {
                      setPayoutAmount("");
                      setShowModal(false);
                    }}
                  />
                  <PrimaryButton
                    disabled={!payoutAmount || payoutAmount === ""}
                    label="Payout"
                    onClick={initializePayout}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(EditUserScreen);
